<div class="table-responsive">
  <div class="card">
    <div class="card-body">

      <div class="row">
        <div class="col-md-12">
          <div class="button-items mb-1" style="float: left;padding-left: 1%;">
            <h2>Time Records Export</h2>
          </div>

          <div class="button-items mb-1" style="float: right;">
            <button class="btn btn-primary btn-sm" (click)="loadExportGrid(lazyloadEvent)" pTooltip="Refresh table" appActionTooltip><i
            class="mdi mdi-reload"></i></button>
            <button class="btn btn-primary btn-sm " (click)="dt.clear()" pTooltip="Clear all column filters and sorting" appActionTooltip>Clear <i class="mdi mdi-filter-remove"></i></button>
            <button class="btn btn-success btn-sm" pTooltip="Generate a new export batch" appActionTooltip (click)="generateData()">Generate Export Data</button>
          </div>
        </div>
      </div>
      <p-table [lazy]="true" #dt [columns]="cols" (onLazyLoad)="loadExportGrid($event)" [value]="timeRecordJobs"
        dataKey="id" styleClass="p-datatable-timeRecordJobs" [rowHover]="true" [rows]="10"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
        responsiveLayout="scroll" [paginator]="true" [autoLayout]="true" [totalRecords]="totalRecords"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0" paginatorDropdownAppendTo="body">


        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="width:6rem">
              Preview/Download
            </th>
            <th pSortableColumn="id">
              <div >
                Batch Id
                <p-sortIcon field="id"></p-sortIcon>
                <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"
                type="numeric" field="id" display="menu"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="createdDate">
              <div >
                Date Created
                <p-sortIcon field="createdDate"></p-sortIcon>
                <p-columnFilter [showOperator]="false" [showAddButton]="false" [matchModeOptions]="matchModeOptionsDate"  type="date" field="createdDate"
                display="menu"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="description">
              <div >
                Description
                <p-sortIcon field="description"></p-sortIcon>
                <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"  type="text" field="description"
                display="menu"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="createdBy">
              <div >
                User Created
                <p-sortIcon field="createdBy"></p-sortIcon>
                <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"  type="text" field="createdBy"
                display="menu"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="recordsCount">
              <div >
                Total Number of Records
                <p-sortIcon field="recordsCount"></p-sortIcon>
                <p-columnFilter matchMode="contains" [showOperator]="false" [showAddButton]="false"  type="text" field="recordsCount"
                display="menu"></p-columnFilter>
              </div>
            </th>

          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-timeRecordJobs let-columns="columns">
          <tr>
            <td>
              <div class="flex align-items-center">
                <button class="btn btn-warning btn-sm mr-2" pTooltip="Preview batch details" appActionTooltip
                  style="margin-right: 4%;"
                  (click)="preview(timeRecordJobs)" role="button"><i
                class="mdi mdi-eye"></i></button>

                <button class="btn btn-success btn-sm mr-2" pTooltip="Download in QuickBooks format" appActionTooltip
                  style="margin-right: 4%;"
                  (click)="download(timeRecordJobs)" role="button"><i
                class="mdi mdi-download"></i></button>
              </div>

            </td>
            @for (col of columns; track col) {
              <td>
                {{timeRecordJobs[col.field] }}
              </td>
            }
          </tr>

        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns && columns.length">
              {{gridCustomMessage?gridCustomMessage:'No records found'}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-dialog [(visible)]="showTrDialog" [resizable]="false" [draggable]="false" (onHide)="closeDialog()"
  [style]="{width: '90%'}" [header]="title" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <app-notification [errorMsg]="errorMsg"></app-notification>

    <p-table #dt [columns]="previewCols"  [(value)]="previewData" dataKey="id" [scrollable]="true" scrollDirection="both"
      scrollHeight="400px" styleClass="p-datatable-daywiseData" responsiveLayout="scroll" rows="5"
      [rowHover]="true" class="insidetable" [loading]="loading" responsiveLayout="scroll">

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th pSortableColumn="date">
            <div >
              Date
              <p-sortIcon field="date"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="orgName">
            <div >
              Organization Name
              <p-sortIcon field="orgName"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="matterName">
            <div >
              Matter Name
              <p-sortIcon field="matterName"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="projectName">
            <div >
              Project Name
              <p-sortIcon field="projectName"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="taskName">
            <div >
              Task Name
              <p-sortIcon field="taskName"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="timeRecDesc">
            <div >
              Time Record Description
              <p-sortIcon field="timeRecDesc"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="expTrDuration">
            <div >
              Time Record Duration
              <p-sortIcon field="expTrDuration"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="billingStatus">
            <div >
              Billing Status
              <p-sortIcon field="billingStatus"></p-sortIcon>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-timeRecordJobs let-columns="columns">
        <tr>
          @for (col of columns; track col) {
            <td>
              {{timeRecordJobs[col.field] }}
            </td>
          }
        </tr>

      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns && columns.length">
            No records found
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-dialog>